import { render, staticRenderFns } from "./SocialScienceManager.vue?vue&type=template&id=a04eddfc&"
import script from "./SocialScienceManager.vue?vue&type=script&lang=js&"
export * from "./SocialScienceManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports